import React, { useEffect, useState } from 'react'
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import ProgressBar from '../../leastcomponent/progressBar/ProgressBar'
import '../dashboard/dashboard.css'
import Card from '../../leastcomponent/cardInfo/card'
import TableWrapper from '../../leastcomponent/dashboardTableWrapper/TableWrapper'
import Activity from '../../leastcomponent/Activity/Activity'
import RecentActivityCard from '../../leastcomponent/Activity/RecentActivityCard'
import BreadcrumbNavigation from '../commoncomponents/breadcrumbnavigation'
import DateRange from '../../leastcomponent/daterabgepicker/customdaterangepicker'
import moment from 'moment'
import {
  useAdminAllCount,
  useDashboardRecentActivity,
  useManagerApprovetask,
  useManagerOngoingtask,
  useManagerOverView,
  useManagerScheduledtask
} from '../../hooks/dashboard'
import CustomSelect from '../../leastcomponent/customselect/customselect'
import JobSlipsDetailsModal from '../../modals/jobcardmodal/jobSlipsDetailsModal'
import { useJobSlipsSingleById } from '../../hooks/jobslipshooks'
import ScheduledIcon from '../../assets/svg/ScheduledIcon'
// import JobcardSchedule from '../jobcards/jobcardSchedule'
import JobCardAddTaskById from '../jobcards/JobCardAddTaskById'
import ArrowsActive from '../../assets/svg/ArrowsActive'
import PendingsActive from '../../assets/svg/PendingActive'
import PushToPendingModal from '../../modals/jobcardmodal/pushToPendingModal'
import Arrows from '../../assets/svg/Arrows'
import Pendings from '../../assets/svg/Pending'
import { useQueryClient } from '@tanstack/react-query'
import { user } from '../../querykeys/usermanagement'
import ScheduleDashboard from '../jobcards/ScheduleDashboard'

const MangerDashBoard = (props) => {
  const currentDate = moment()
  const weekStart = currentDate.clone().startOf('today')
  const weekEnd = currentDate.clone().endOf('today')
  // const navigate = useNavigate()
  const [ganttDates, setGranttDatesState] = useState({
    startDate: moment(weekStart).format('DD MMM, YY'),
    endDate: moment(weekEnd).format('DD MMM, YY')
  })
  const setGranttDates = (e, { startDate, endDate }) => {
    setGranttDatesState({
      startDate: startDate.format('DD MMM, YY '),
      endDate: endDate.format('DD MMM, YY')
    })
  }
  const [isCnfModalOpen, setIsCnfModalOpen] = React.useState(false)
  const [pushToPendingId, setPushToPendingId] = React.useState('')
  const [jcNum, setJcNum] = React.useState('')
  const queryClient = useQueryClient()
  const userData = queryClient.getQueryData([user.LOGGED_IN_USER])
  const departmentData = userData?.data?.data?.user?.roleId?.departmentGroup
  const departmentName = localStorage.getItem('departmentName')
  const [selectedDepartment, setSelectedDepartment] = useState(departmentName)
  const { data: GetJobSlipsSingleById } =
    useJobSlipsSingleById(selectedDepartment)
  const [jobName, setJobName] = useState({ name: '', code: '' })
  const [jobAdd, setJobAdd] = useState({ name: '', code: '' })
  const [jobSchedule, setJobSchedule] = useState({ name: '', code: '' })
  const [tasks, setTasks] = useState({})
  const [taskId, setTaskId] = useState('')
  const [partId, setPartId] = useState('')
  const [jobCardModel, setJobCardModel] = useState('')
  const [jobCardTask, setJobCardTask] = useState('')
  const [jobcardSchedule, setJobcardSchedule] = useState('')
  const handleDetailsClose = () => {
    setJobCardModel(false)
    setJobCardTask(false)
    setJobcardSchedule(false)
  }

  const handleSelectChange = (selectedOption) => {
    setSelectedDepartment(selectedOption?.target?.value)
    localStorage.setItem('departmentName', selectedOption?.target?.value)
  }
  // dapartment full list api
  // const { data: departmentData } = useGetFullDepartments()

  // dashboard recent activity api useDashboardRecentActivity
  const { data: dashboardRecentData, isFetching: isDashboardRecentData } =
    useDashboardRecentActivity(true, ganttDates)
  const dashboardRecent = dashboardRecentData?.data

  // Jobcard onoing task api
  const { data: managerOngoingTask, isFetching: isManagerOngoingtask } =
    useManagerOngoingtask(true, 1, ganttDates, selectedDepartment)
  const managerOngoing = managerOngoingTask?.[0]?.tasks

  // Jobcard Scheduled task api
  const {
    data: dashboardTaskStatusCompleted,
    isFetching: isDashboardTaskStatusCompleted
  } = useManagerScheduledtask(true, 1, ganttDates, selectedDepartment)
  const dashboardTaskStatusCompletedData =
    dashboardTaskStatusCompleted?.[0]?.parts

  // jobcard Approve task api
  const { data: managerApproveTask, isFetching: isManagerApprovetask } =
    useManagerApprovetask(true, 1, ganttDates, selectedDepartment)
  const managerApprove = managerApproveTask?.[0]?.parts

  // over view chart
  const { data: dashboardTaskOverview, isFetching: isDashboardTaskOverview } =
    useManagerOverView(selectedDepartment)

  // four box all count
  const { data: adminAllCount } = useAdminAllCount()
  const adminAllCountData = adminAllCount?.data

  // Row for All
  const rowsApproved = managerApprove?.map((data, index) => {
    return {
      no: index + 1,
      id: data?.id,
      partId: data?.bomparts?.id ? data?.bomparts?.id : '-',
      taskLength: data?.bomparts?.taskLength ? data?.bomparts?.taskLength : '-',
      bomprocessesId: data?.bomparts?.bomprocesses?.[0]?.id
        ? data?.bomparts?.bomprocesses?.[0]?.id
        : '-',
      part: data?.bomparts?.partName ? data?.bomparts?.partName : '-',
      partCode: data?.bomparts?.itemCode ? data?.bomparts?.itemCode : '-',
      drawingNumber: data?.bomparts?.drawingNumber
        ? data?.bomparts?.drawingNumber
        : '-',
      jobCard: data?.jobCard ? data?.jobCard : '-',
      jobCardId: data?.bomparts?.jobCardId ? data?.bomparts?.jobCardId : '-',
      quantity: data?.bomparts?.quantity ? data?.bomparts?.quantity : '-'
    }
  })
  const rowsOngoing = managerOngoing?.map((data, index) => {
    return {
      no: index + 1,
      id: data?.task?.id,
      taskNickName: data?.task?.taskNickName ? data?.task?.taskNickName : '-',
      part: data?.partName ? data?.partName : '-',
      jobCard: data?.task?.jobCardId?.jobCardNumber
        ? data?.task?.jobCardId?.jobCardNumber
        : '-'
    }
  })
  const rowsCompleted = dashboardTaskStatusCompletedData?.map((data, index) => {
    return {
      no: index + 1,
      id: data?.bomparts?.task?.[0]?.id,
      partId: data?.bomparts?.id ? data?.bomparts?.id : '-',
      part: data?.bomparts?.partName ? data?.bomparts?.partName : '-',
      jobCard: data?.jobCard ? data?.jobCard : '-',
      productCode: data?.productCode ? data?.productCode : '-',
      customerName: data?.customerName ? data?.customerName : '-',
      totalTaskCount: data?.totalTaskCount ? data?.totalTaskCount : '-',
      quantity: data?.bomparts?.quantity ? data?.bomparts?.quantity : '-',
      partStatus: data?.bomparts?.partStatus ? data?.bomparts?.partStatus : '-',
      jobCardId: data?.bomparts?.jobCardId ? data?.bomparts?.jobCardId : '-'
    }
  })
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  const ongoingColumns = [
    { field: 'no', headerName: '#', width: 70, flex: matches ? 0.5 : 0 },
    {
      field: 'taskNickName',
      headerName: 'Task Name ',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    { field: 'part', headerName: 'Part ', width: 150, flex: matches ? 1 : 0.7 },
    {
      field: 'jobCard',
      headerName: 'Job Card',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: matches ? 1 : 0.7,
      renderCell: (params) => {
        return (
          <Box className="resource-table-btn-main">
            <span
              className="process-delete"
              onClick={() => {
                setJobName({
                  ...jobName,
                  name: params?.row?.jobName,
                  code: params?.row?.jobCode
                })
                setTasks({
                  history: [
                    { taskId: params?.id, taskNickName: params?.row?.name }
                  ]
                })
                setJobCardModel(true)
              }}
            >
              Update
            </span>
          </Box>
        )
      }
    }
  ]
  const approvedColumns = [
    { field: 'no', headerName: '#', width: 70, flex: matches ? 0.2 : 0 },
    { field: 'part', headerName: 'Part ', width: 150, flex: matches ? 1 : 0.7 },
    {
      field: 'jobCard',
      headerName: 'Job Card',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    { field: 'quantity', headerName: 'Qty', flex: matches ? 1 : 0.7 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: matches ? 1 : 0.7,
      renderCell: (params) => {
        return (
          <Box className="resource-table-btn-main">
            <span
              onClick={() => {
                setJobAdd({
                  ...jobAdd,
                  name: params?.row?.jobAdd,
                  code: params?.row?.jobCode
                })
                setTasks({
                  history: [
                    {
                      taskId: params?.row?.id,
                      taskNickName: params?.row?.name
                    }
                  ]
                })
                setJobCardTask(true)
                setTaskId(params?.row?.jobCardId)
                setPartId(params?.row?.partId)
              }}
            >
              Add Task
            </span>
            <div
              className={
                params?.row?.taskLength > 0
                  ? 'nested-actions-push-cursor-pointer'
                  : 'nested-actions-push'
              }
              onClick={() => {
                if (params?.row?.taskLength > 0) {
                  setIsCnfModalOpen(true)
                  setPushToPendingId(params?.row?.bomprocessesId)
                  setJcNum(params?.row?.number)
                }
              }}
            >
              {params?.row?.taskLength > 0
                ? (
                <>
                  <ArrowsActive />
                  <PendingsActive />
                </>
                  )
                : (
                <>
                  <Arrows style={{ marginLeft: '10px', marginRight: '0px' }} />
                  <Pendings />
                </>
                  )}
            </div>
          </Box>
        )
      }
    }
  ]

  const scheduleColumns = [
    { field: 'no', headerName: '#', width: 70, flex: matches ? 0.2 : 0 },
    { field: 'part', headerName: 'Part ', width: 150, flex: matches ? 1 : 0.7 },
    {
      field: 'jobCard',
      headerName: 'Job Card',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    {
      field: 'totalTaskCount',
      headerName: 'Total Task',
      flex: matches ? 1 : 0.7
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: matches ? 1 : 0.7,
      renderCell: (params) => {
        return (
          <Box className="resource-table-btn-main">
            <span
              onClick={() => {
                setJobSchedule({
                  ...jobSchedule,
                  name: params?.row?.jobSchedule,
                  code: params?.row?.jobCode
                })
                setTasks({
                  history: [
                    {
                      taskId: params?.row?.id,
                      taskNickName: params?.row?.name
                    }
                  ]
                })
                setJobcardSchedule(true)
                setTaskId(params?.row?.jobCardId)
                setPartId(params?.row?.partId)
              }}
            >
              <ScheduledIcon />
            </span>
          </Box>
        )
      }
    }
  ]

  const options = departmentData?.departments?.map((item) => {
    return {
      value: item?.id,
      label: item?.name
    }
  })
  useEffect(() => {
    if (options?.[0]?.value && !departmentName) {
      setSelectedDepartment(options?.[0]?.value)
    }
  }, [options?.[0]?.value])
  return (
    <React.Fragment>
      <Box className="dash-border-main-box">
        <Box>
          <BreadcrumbNavigation
            breadCrumbData={null}
            pageTitle={'Dashboard'}
            backToLink={null}
          />
        </Box>
        <Box className="dash-border-box-over">
          <Box sx={{ padding: '16px 20px', display: 'flex', gap: '10px' }}>
            <Box>
              <DateRange
                setDatesState={setGranttDatesState}
                dates={ganttDates}
                setDates={setGranttDates}
              />
            </Box>
            <Box sx={{ width: '228px' }}>
              <CustomSelect
                name="department"
                isRequired={false}
                islabel={false}
                placeholder="Select Department"
                className="default-select-new"
                options={options}
                value={selectedDepartment}
                handleSelectChange={handleSelectChange}
              />
            </Box>
          </Box>
          <Box sx={{ padding: '16px 20px' }}>
            <Grid container className="parent-details-info" spacing={0}>
              {/* Left Section */}
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  {/* Cards Section */}
                  <Grid item xs={6} md={3}>
                    <Card
                      title={'Total Job Card'}
                      data={adminAllCountData?.totalJobCards}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Card
                      title={'Total Parts'}
                      data={adminAllCountData?.totalBomparts}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Card
                      title={'Total Tasks'}
                      data={adminAllCountData?.totalTasks}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Card
                      title={'Total Breakdowns'}
                      data={adminAllCountData?.totalBreakdown}
                    />
                  </Grid>

                  {/* Job Card Status */}
                  <Grid item xs={12}>
                    {!isDashboardTaskOverview
                      ? (
                      <Box className="parent-job-details">
                        <Typography className="job-title">
                          Task Overview
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <ProgressBar
                              title="In progress"
                              value={dashboardTaskOverview?.inProgress}
                              color="#54D14D"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ProgressBar
                              title="Cancelled"
                              value={dashboardTaskOverview?.cancelled}
                              color="#0160B9"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ProgressBar
                              title="Not started"
                              value={dashboardTaskOverview?.notStarted}
                              color="#EF7E5D"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ProgressBar
                              title="Completed"
                              value={dashboardTaskOverview?.completed}
                              color="#EF1060"
                            />
                          </Grid>
                        </Grid>
                      </Box>
                        )
                      : (
                      <Box className="progress-parent-dashboard-jobcard-status">
                        <CircularProgress />
                      </Box>
                        )}
                  </Grid>
                  <Grid item xs={12}>
                    {!isManagerOngoingtask
                      ? (
                      <TableWrapper
                        rows={rowsOngoing}
                        columns={ongoingColumns}
                        isShowFiveRecords={true}
                        title="Ongoing Tasks"
                        view="View All"
                        to={{
                          path: '/job-card-department',
                          state: { activeTab: '3' }
                        }}
                        totalParts={managerOngoingTask?.[0]?.totalParts}
                        totalTasks={managerOngoingTask?.[0]?.totalTask}
                      />
                        )
                      : (
                      <Box className="progress-parent-dashboard-table">
                        <CircularProgress />
                      </Box>
                        )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={4}>
                <Box
                  style={{
                    marginLeft: '12px',
                    border: '1px solid #DEDEDE',
                    height: '100%'
                  }}
                >
                  {!isDashboardRecentData
                    ? <>
                      <Activity
                      Component={RecentActivityCard}
                      // height={'533px'}
                      title={'Recent Activity'}
                      isViewAll={true}
                      viewAllLink={'/recent-activity'}
                      data={dashboardRecent || []}
                    />
                    </>

                    : <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  }
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="parent-details-info">
              <Grid item xs={12} md={6} lg={6} className="parent-spacing">
                {!isManagerApprovetask
                  ? (
                  <TableWrapper
                    rows={rowsApproved}
                    columns={approvedColumns}
                    isShowFiveRecords={true}
                    title="Approved Job Cards : Parts"
                    view="View All"
                    to={{
                      path: '/job-card-department',
                      state: { activeTab: '1' }
                    }}
                    totalParts={managerApproveTask?.[0]?.totalParts}
                    showTotalTasks={false}
                    isBottomTitle={true}
                  />
                    )
                  : (
                  <Box className="progress-parent-dashboard-table">
                    <CircularProgress />
                  </Box>
                    )}
              </Grid>
              <Grid item xs={12} md={6} lg={6} className="parent-spacing">
                {!isDashboardTaskStatusCompleted
                  ? (
                  <TableWrapper
                    rows={rowsCompleted}
                    columns={scheduleColumns}
                    isShowFiveRecords={true}
                    title="Scheduled Tasks: Parts"
                    view="View All"
                    to={{
                      path: '/job-card-department',
                      state: { activeTab: '2' }
                    }}
                    isBottomTitle={true}
                    showTotalTasks={true}
                    totalParts={dashboardTaskStatusCompleted?.[0]?.totalParts}
                    totalTasks={dashboardTaskStatusCompleted?.[0]?.totalTasks}
                  />
                    )
                  : (
                  <Box className="progress-parent-dashboard-table">
                    <CircularProgress />
                  </Box>
                    )}
              </Grid>
            </Grid>
          </Box>
          {jobCardModel && (
            <JobSlipsDetailsModal
              tasks={tasks}
              jobName={jobName}
              processData={GetJobSlipsSingleById}
              open={jobCardModel}
              DetailsHandleClose={handleDetailsClose}
              setOpen={() => setJobCardModel(false)}
              isGoBackDashboard={true}
            />
          )}
          {jobCardTask && (
            <JobCardAddTaskById
              selectedDepartment={selectedDepartment}
              tasks={tasks}
              jobName={jobAdd}
              id={taskId}
              partId={partId}
              open={jobCardTask}
              DetailsHandleClose={handleDetailsClose}
              setOpen={() => setJobCardTask(false)}
            />
          )}
          {jobcardSchedule && (
            <ScheduleDashboard
              selectedDepartment={selectedDepartment}
              tasks={tasks}
              id={taskId}
              partId={partId}
              jobName={jobSchedule}
              open={jobcardSchedule}
              DetailsHandleClose={handleDetailsClose}
              setOpen={() => setJobcardSchedule(false)}
              isGoBackDashboard={true}
            />
          )}
          {isCnfModalOpen && (
            <PushToPendingModal
              id={pushToPendingId}
              jcNum={jcNum}
              open={isCnfModalOpen}
              isGoBackDashboard={true}
              handleClose={() => setIsCnfModalOpen(false)}
            />
          )}
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default MangerDashBoard
